import PropTypes from 'prop-types'
import { Element } from '../html/element'

export const Separator = ({ backgroundColor, width, height, margin }) => {
  return <Element style={{ backgroundColor, width, height, margin }} />
}

Separator.propTypes = {
  backgroundColor: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

Separator.defaultProps = {
  backgroundColor: '#FFFFFF',
}
